package com.essntl.features.price.data.supabase.proposalserviceprice

import com.essntl.features.price.domain.model.proposalserviceprice.ProposalServicePriceModel
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

@OptIn(ExperimentalSerializationApi::class)
internal fun ProposalServicePriceModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    requestMap["visibility"] = JsonPrimitive(visibility.toDto())

    return requestMap
}